import http from '@/http/driver'

export default {
  planner: {
    search(data = {}) {
      return http({ url: '/v1/journey-planner/search', method: 'post', data })
    },
  },
}
